import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LinerOriginServiceFormComponent } from "./liner-origin-service-form/liner-origin-service-form.component";
import { LinerOriginServiceListComponent } from "./liner-origin-service-list/liner-origin-service-list.component";

const routes:Routes=[
    {
        path:'',
        data:{
            title:'Liner Origin Service'
        },
        component:LinerOriginServiceListComponent
    },
    {
        path:'add',
        data:{
            title:'Add Liner Origin Service'  
        },
        component:LinerOriginServiceFormComponent
    },
    {
        path:'edit/:id',
        data:{
            title:'Edit Linear Origin Service'  
        },
        component:LinerOriginServiceFormComponent
    },
]

@NgModule({
    imports:[RouterModule.forChild(routes)],
    exports:[RouterModule]
})
export class LinerOriginServiceRoutingModule{

}